import React, { Component } from 'react'
import { connect } from 'react-redux'

export class About3DS2 extends Component {
    render() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className="stepPageContainer">
                    <span className="stepPageTitle"><b>About 3D Secure 2.2</b></span>
                    <div style={{marginTop: '5vh'}}>
                        <p>3-D Secure 2.2 is an EMVCo payment authentication protocol designed to reduce card not present fraud by making a risk assessment based on transaction and device data, while also supporting further risk minimization measures, such as a challenge to the cardholder. In some cases, a liability shift takes effect for certain card-not-present fraud-related chargebacks enabling the merchant to provide goods and services with confidence.</p>
                        <p>The Moneris Gateway can enable transactions using the 3-D Secure protocol via Moneris 3DS Server and Access Control Server (ACS).</p>
                        <p>Moneris Gateway supports the following 3-D Secure implementations:</p>
                        <ul>
                            <li>Visa Secure (please note: Visa Secure does not support all the RI Indicators available in the 3D Secure 2.2. Check the RI Indicators status field to confirm the status Visa Secure support.)</li>
                            <li style={{ marginTop: '2vh', marginBottom: '2vh' }}>MasterCard Identity Check</li>
                            <li>American Express SafeKey (please note American Express only supports authentication requests for merchants who have an AMEX OFI merchant account)</li>
                        </ul>
                    </div>

                    <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>1.1 3-D Secure Implementations</h3>
                    <div style={{ paddingLeft: '1vw'}}>
                        <p>Visa Secure, MasterCard Identity Check and American Express SafeKey are programs based on the 3-D Secure Protocol to improve the security of online transactions.</p>
                        <p>These programs involve authentication of the cardholder during an online e-commerce transaction.</p>
                        <p>Authentication is based on the issuer’s selected method of authentication.</p>
                        <p>The following are examples of authentication methods:</p>
                        <ul>
                            <li>Risk-based authentication</li>
                            <li style={{ marginTop: '1vh', marginBottom: '1vh' }}>Dynamic passwords</li>
                            <li>Static passwords</li>
                        </ul>
                        <p>Some benefits of these programs are reduced risk of fraudulent transactions and protection against chargebacks for certain fraudulent transactions.</p>
                        <p>The XML 3DS 2.2 API supports two message categories and two device channels from the 3-D Secure authentication protocol:</p>
                        <ol>
                            <li>
                                Message Categories:
                                <ul>
                                    <li>
                                        <p><strong>Payment Authentication</strong> – Cardholder authentication prior to an eCommerce transaction. After a successful 3DS authentication, you proceed with a purchase or pre-authorization.</p>
                                    </li>
                                    <li>
                                        <p><strong>Non-Payment Authentication (NPA)</strong> – Identity verification and account confirmation performed without an accompanying financial transaction. After a successful 3DS authentication, you might proceed with:
                                            <ul>
                                                <li>Tokenizing the card for future payments</li>
                                                <li>Allowing log-in for client portals</li>
                                                <li>Any other activity relying on identity or account confirmation</li>
                                            </ul>
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Device Channels:
                                <ul>
                                    <li>
                                        <p><strong>Browser</strong> – The transaction originates from a website utilized via a browser on the cardholder’s device.</p>
                                        <ul>
                                            <li>For example, an eCommerce transaction originating on the merchant’s website with a check-out process that the cardholder is using via their personal computer or mobile phone’s web browser (Chrome, Edge, Safari, etc.).</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <p><strong>3DS Requestor Initiated</strong> – Account confirmations and cardholder authentication with no direct cardholder originating the transaction.
                                            <ul>
                                                <li>3RI can be used for authenticating Mail-Telephone Order (MOTO) transactions.</li>
                                                <li>3RI can be used to authenticate follow-on transactions as part of a subscription, such as recurring transactions. The first cardholder payment might use a browserbased authentication, with subsequent payments utilizing a 3RI authentication linking to the previous.</li>
                                                <li>In situations where a merchant business model accommodates waiting before processing their payment, they can utilize Decoupled Authentication to allow the cardholder to authenticate directly with their issuer via a non-3DS challenge, such as a push notification to a banking app.</li>
                                            </ul>
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>

                    <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>1.2 Out of Scope/Not Supported</h3>
                    <p style={{ paddingLeft: '1vw'}}>In-app.</p>

                    <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>1.3 Version Compatibility</h3>
                    <p style={{ paddingLeft: '1vw'}}>All development to the Moneris API must be able to support the addition of new fields in the response and new error conditions in the response. Otherwise any changes that affect backwards compatibility will be communicated by Moneris Solutions with an appropriate period of notice. When developing to the solution it is recommended to validate for success state of the request and then handle errors states separately and ensure there is a final catch for any unexpected/undocumented errors that are returned.</p>

                    <h3 style={{ marginTop: '7vh', color: '#00a1cb'}}>1.4 Upgrading from 3-D Secure 2.0 to 3-D Secure 2.2 Check</h3>
                    <p style={{ paddingLeft: '1vw'}}>The 3DS 2.2 API is different from the 3DS 2.0 API therefore developers will have to complete the steps described in the next section Building Your 3-D Secure 2.2 Integration.</p>
                </div>
            )
        }
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode };
}

export default connect(mapStateToProps, {})(About3DS2)
